<template>
  <div>
    <ValidationObserver
      ref="observer"
      v-slot="{ valid, dirty }"
    >
      <NavTabs
        customClass="capitalize_title"
        :tabs="tabs"
        :activeTab="newActiveTab"
        @sendData="updateData($event)"
      />
      <SlotScopeWatcher
        :value="dirty"
        @change="$emit('dirtyChanged', dirty)"
      />
      <SlotScopeWatcher
        :value="valid"
        @change="$emit('validChanged', valid)"
      />
    </ValidationObserver>
    <div />
  </div>
</template>


<script>
import { mapGetters } from 'vuex';

import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';

import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import Vue from 'vue';
import Informations from './Informations.vue';
import Sites from './Site.vue';


export default {
    components: {
        NavTabs,
        SlotScopeWatcher,
        ValidationObserver,
    },
    props: {
        memberId: {
            type: String,
            default: '',
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            components: [Informations, Sites],
            tabs: [],
            summaryStep: 2,
            mutableValue: {
                name: '',
                lastName: '',
                phone: '',
                email: '',
            },

            empty: {
                name: '',
                lastName: '',
                phone: '',
                email: '',
            },
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'userLang',
            'getSteps',
            'getSample',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
    },
    async created() {
        this.$store.dispatch('changeActiveTab', 0);
        if (this.memberId) {
            await this.getMemberInfo();
        } else {
            this.mutableValue = { ...this.empty };
        }
        this.tabs = this.tableHeaders();
    },
    methods: {
        tableHeaders() {
            const payload = { mutableValue: this.mutableValue };
            const headerTitle = ['informations', 'sites'];
            const headers = this.components.map((component, index) => ({
                index,
                props: {
                    ...payload,
                    memberId: this.memberId,
                    selectedGroups: headerTitle[index] === 'analysisTypes' ? this.sample.selectedAnalysisGroups : [],
                },
                name: this.$t(`forms.labels.${headerTitle[index]}`),
                component: Vue.component(`tab-${index}`, component),
                disabled: false,
            }));
            return headers;
        },
        updateData(payload) {
            this.$emit('sendData', payload);
        },
        async getMemberInfo() {
            const { data } = await this.$rq.getMemberInfo(this.memberId);
            this.mutableValue = data;
        },
    },
};
</script>
